module.exports = __webpack_public_path__ + "static/media/map-icon.0dd02781.png";